import React from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'antd';
import { Footer , Header} from '../index';
import './ingenieur.css'


const items = [
  {
    key: '1',
    label:' Diplôme : Ingénieurs Informatique', 
    children: 
          <div>
                <p>    <h6>DESCRIPTION</h6> 
                        Ingénieurs en génie logiciels .<br/>
                        La filière Génie Logiciel est une formation qui vise à former des ingénieurs spécialisés dans les méthodes
                        d'analyse et de conduite de projets informatiques, ainsi que dans les langages et les outils nécessaires au 
                        développement de logiciels. Les diplômés de cette filière seront compétents pour suivre et piloter toutes les
                        étapes du cycle de vie d'un projet informatique, ce qui leur permettra de s'intégrer efficacement dans des
                        équipes de développement ou d'assumer des responsabilités de chef de projet. <br/>

                        Les objectifs principaux de la filière Génie Logiciel sont les suivants : <br/>

                        - Maîtrise des méthodes d'analyse.<br/>

                        - Conduite de projets informatiques.<br/>

                        - Maîtrise des langages et outils de développement.<br/>

                        - Compétences en gestion.<br/>

                        - Compréhension du cycle de vie du projet.<br/>

                        En fin de formation, les diplômés de la filière Génie Logiciel seront capables de concevoir, développer, tester et maintenir des logiciels 
                        de haute qualité, et d'assumer des responsabilités de chef de projet dans des projets informatiques de grande envergure. Ils seront également
                        aptes à s'adapter aux évolutions technologiques et aux besoins changeants de l'industrie du logiciel, ce qui leur permettra de réussir leur 
                        carrière dans le domaine du génie logiciel.<br/>
                    <span className='sous-title'>Plan d'études : </span>
                     <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/ING_Info.pdf" target="_blank" rel="noopener"><span >Cliquer ici</span></a> </p> 
          </div>
,
  },
  {
    key: '2',
    label: ' Diplôme : Ingénieurs électronique et microélectronique',
    children:<div>
                <p>    
                    <span className='sous-title'>Plan d'études : </span>
                    <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/PlanDesEtudes-ING-ElecuElec-2021-2022.pdf" target="_blank" rel="noopener"><span >Cliquer ici</span></a> </p> 
             </div>
  },
  
];
    function Ingenieurie() {
        const onChange = (key) => {
            console.log(key);
        };
    return (
        <>
        <Header/>
  
         <div className='containerIng'>
        <div className='bgING'>  </div>
        <div className='ligne'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-287px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'55px'}}className="container-fluid text-white text-center ">Cycle d'ingénieur</h1>
          <p ><Link className='linkIng' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkIng'
            to="/"> Formation </Link>  <span>{'>'}</span> <Link className='linkIng'
            to="/">Cycle d'ingénieur</Link> </p></div>
      </div>


          <div className='Collapse' >
              <div className='ligne1'>  </div>

              <Collapse style={{ borderRadius: 0 , minWidth: '100%' , minHeight: '200px'}}  size="large" items={items} defaultActiveKey={['1']} onChange={onChange} />
          </div>
        
        <Footer/>
        </>

    ) ;
}

export default Ingenieurie;